// @flow
import { createReducer } from 'actions';
import { LOAD_ALL_USERS } from 'actions/users';
import type { User, LoadAllUsersAction } from 'actions/users';

type State = {
  all: Array<User>,
};

const initialState: State = {
  all: [],
};

export default createReducer(initialState, {
  [LOAD_ALL_USERS]: (state: State, action: LoadAllUsersAction) => {
    if (action.meta.done && !action.meta.error && action.payload) {
      return {
        ...state,
        all: [...action.payload],
        error: null,
      };
    }
    return state;
  },
});



// WEBPACK FOOTER //
// ./src/redux/reducers/users.js